import React from 'react';

// Typeset wordmark for the publication (no logo file supplied).
export function BeyondTheLobbyMark({
  className = ''
}: {
  className?: string;
}) {
  return <span className={`inline-flex items-start font-display font-medium uppercase tracking-[0.06em] text-ink ${className}`} data-id="element-3" data-mp="3majld8p75omm">
      Beyond
      <span className="mx-[0.12em] mt-[0.15em] text-[0.38em] font-semibold tracking-[0.04em]" data-id="element-4" data-mp="3db6aqcpc6u0b">The</span>
      Lobby
    </span>;
}